import './styles/match-card-root.scss';
import Football2Icon from "./icons/Football2Icon";
import { useEffect, useState } from 'react';

const MatchCard = ({ teamA, teamB, oddA, oddAB, oddB, matchId, lastUpdated }) => {
    // State to track which odds are highlighted
    const [highlightedOdd, setHighlightedOdd] = useState(null);

    // Effect to handle highlighting when odds are updated
    useEffect(() => {
        // Check if this match has an updated odd
        if (lastUpdated && lastUpdated.matchId === matchId && lastUpdated.oddType) {
            // Set the highlighted odd
            setHighlightedOdd(lastUpdated.oddType);

            // Clear the highlight after animation completes
            const timer = setTimeout(() => {
                setHighlightedOdd(null);
            }, 1000); // Match the animation duration

            return () => clearTimeout(timer);
        }
    }, [lastUpdated, matchId]);

    return (
        <div className='match-card-root'>
            <div className='flex justify-between'>
                <div className='flex gap-2 items-center'>
                    <Football2Icon />
                    <h4>Premier League</h4>
                </div>

                <h4>Feb 2, 00:00</h4>
            </div>

            <div className='flex justify-between items-center'>
                <div className='flex flex-col gap-2'>
                    <div className='team-frame'>
                        <img src={`images/teams/${teamA}.png`} alt='team-a' />
                    </div>
                    <h5 className='text-white open-sans-semibold'>{teamA}</h5>
                </div>
                <span>VS</span>
                <div className='flex flex-col gap-2 items-end'>
                    <div className='team-frame'>
                        <img src={`images/teams/${teamB}.png`} alt='team-a' />
                    </div>
                    <h5 className='text-white open-sans-semibold'>{teamB}</h5>
                </div>
            </div>

            <div className='flex justify-between gap-5'>
                <div className={`score-frame ${highlightedOdd === 'oddA' ? 'highlight-update' : ''}`}>
                    <div className='flex justify-around'>
                        <span className='tertiary-color'>1</span>
                        <span className='text-white'>{oddA}</span>
                    </div>
                </div>

                <div className={`score-frame ${highlightedOdd === 'oddAB' ? 'highlight-update' : ''}`}>
                    <div className='flex justify-around'>
                        <span className='tertiary-color'>X</span>
                        <span className='text-white'>{oddAB}</span>
                    </div>
                </div>

                <div className={`score-frame ${highlightedOdd === 'oddB' ? 'highlight-update' : ''}`}>
                    <div className='flex justify-around'>
                        <span className='tertiary-color'>2</span>
                        <span className='text-white'>{oddB}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MatchCard;
